import React, { createContext, useContext, useEffect, useState } from "react";
import { supabase } from "../tattoo/lib/supabaseClient";

const AuthCtx = createContext({ session: null, loading: true });
export function useAuth() { return useContext(AuthCtx); }

export default function AuthProvider({ children }) {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await supabase.auth.getSession();
        if (mounted) setSession(data?.session ?? null);
      } catch {}
      finally { if (mounted) setLoading(false); }
    })();

    const { data: sub } = supabase.auth.onAuthStateChange((_event, sess) => {
      setSession(sess ?? null);
    });
    return () => { mounted = false; sub?.subscription?.unsubscribe?.(); };
  }, []);

  return <AuthCtx.Provider value={{ session, loading }}>{children}</AuthCtx.Provider>;
}
